import axios from "axios";

const API_KEY =
  "XO5zfvA6BI0Yo5XGeivstumrVwYaLaEWkDoY1OYQpyQfxxMXvihll5CCNJHiAURiNUzicUyGCu38RgLB";

const axiosInstance = axios.create({
  baseURL: "https://host.bbdevs.xyz:3210",
  withCredentials: true,
  headers: {
    "x-api-key": API_KEY,
  },
});

axiosInstance.interceptors.request.use((config) => {
  return config;
});

export default axiosInstance;
